var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-modal',{attrs:{"modal":_vm.modal,"title":_vm.$t('logs.details.page-heading'),"hideSubmitButton":true},on:{"closeModal":_vm.handleCloseModal}},[_c('template',{slot:"body"},[_c('v-row',[_c('v-col',{staticClass:"mb-3",attrs:{"cols":"12"}},[_c('BaseLog',{attrs:{"getLogs":_vm.getLogs,"hideDetails":true}})],1)],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }